<template>
	<div class="flavor-card"> 
        <div class="container" style="position: relative"> 
            <h4><b>{{ flavor.name }}</b></h4>
            <span class="vqid">{{flavor.vqid}}</span>
            <hr style="border-color: gray; margin: 10px;"/>
			<p>{{ flavor.description }}</p> 
		</div> 
	</div>
</template>

<script>
export default {
    props: ['flavor']
}
</script>

<style lang="scss">
.flavor-card {
    .vqid {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .even {
        background: white;
    }
	background: #97d3ce;	
    font-family: Nunito Sans;
    color: white;
    text-align: center;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.5);
    transition: 0.3s;
	width: 300px;
	margin: 10px;
    .hr {
        height: 20px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .container {
        display: flex;
        flex-direction: column;
        padding: 20px;
        margin: 0;
    }
}

    .container {
        padding: 20px;
        margin: 0;
    }

.topper {
	width: auto;
	background-size: contain;
	background-repeat: no-repeat;
	background-postition: 50% 50%;
}

.flavor-card:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.5);
}

</style>
